import { render } from "./ImprestAccauntantPage.vue?vue&type=template&id=407bdaf4"
import script from "./ImprestAccauntantPage.vue?vue&type=script&lang=js"
export * from "./ImprestAccauntantPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__